// extracted by mini-css-extract-plugin
export default {"copyToClipBoardContainer":"TenantFeatureProgressModal_copyToClipBoardContainer__jedfY","terminatedSteps":"TenantFeatureProgressModal_terminatedSteps__0yEx+"};